import React from 'react';

const Minus = () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 4'>
        <path fill='currentColor' d='M0 0H12V4H0z'></path>
    </svg>
);

export default Minus;
